import React, { memo } from "react";

import LinkData from "./Lisks.json";
import { useLocation } from "react-router-dom";
import { DrawerMain, LinkMain, LinkTo } from "./HeaderStyle";

const MobileMenu = ({ isDrawerOpen, handleCloseNavMenu }) => {
  const location = useLocation();
  return (
    <>
      <DrawerMain
        anchor="left"
        open={isDrawerOpen}
        onClose={handleCloseNavMenu}
      >
        <LinkMain>
          {LinkData.homeLink.map((value) => {
            const IsProfilePages = [
              "/profile-change-password",
              "/profile-pay-methods",
              "/profile-edit-card",
            ];
            const IsMyOrderPages = [
              "/my-orders",
              "/order-quotes",
              "/order-details",
              "/order-label",
            ];

            const TransactionPage = [
              "/transaction-paid",
              "/transaction-unpaid",
            ];

            const isActiveLink =
              location.pathname === value.url ||
              (IsProfilePages.includes(location.pathname) &&
                value.title === "Profile") ||
              (IsMyOrderPages.includes(location.pathname) &&
                value.title === "My Orders") ||
              (TransactionPage.includes(location.pathname) &&
                value.title === "My Transactions");

            return (
              <li>
                <LinkTo
                  to={value.url}
                  key={value.title + "__" + value?.url}
                  className={isActiveLink ? "active_link" : ""}
                >
                  {value.title}
                </LinkTo>
              </li>
            );
          })}
        </LinkMain>
      </DrawerMain>
    </>
  );
};

export default memo(MobileMenu);
